import {Content} from '@volkswagen-onehub/fa-content-service';
import * as React from 'react';
import {useFeatureServices} from './use-feature-services';
import {Background} from './components/background/background';
import './';
import {MirroredImageContainer} from './components/main-image-container/mirrored-image-container';
import {IdMirrorCards} from './components/cards-container/id-mirror-cards';
import {
  AspectRatioWrapper,
  Breakpoints,
  BreakpointWrapper,
} from '@volkswagen-onehub/components-core';
import {IdMirrorCarousel} from './components/cards-container/id-mirror-carousel';
import {SliderImageContainer} from './components/main-image-container/slider-image-container';
import {MainText} from './components/main-text/main-text';

export function Home({content: _content}: {content: Content}): JSX.Element {
  const {
    'breadcrumb-service': breacrumbService,
    'page-info-service': pageInfoService,
  } = useFeatureServices();

  React.useEffect(() => {
    breacrumbService.set([]);
    pageInfoService.setPageInfo();
  }, [pageInfoService, breacrumbService]);

  return (
    <Background>
      <MainText />

      {/* Mobile 0-960: siempre slider + carousel */}
      <BreakpointWrapper max={Breakpoints.b960}>
        <SliderImageContainer />
        <IdMirrorCarousel />
      </BreakpointWrapper>

      {/* Tablet/Desktop 960-1280: slider + carousel (vertical) cards + mirrored image (horizontal) */}
      <BreakpointWrapper min={Breakpoints.b960} max={Breakpoints.b1280}>
        <AspectRatioWrapper max="1:1">
          <SliderImageContainer />
          <IdMirrorCarousel />
        </AspectRatioWrapper>

        <AspectRatioWrapper min="1:1">
          <IdMirrorCards />
          <MirroredImageContainer />
        </AspectRatioWrapper>
      </BreakpointWrapper>

      {/* Desktop +1280: cards + mirrored image */}
      <BreakpointWrapper min={Breakpoints.b1280}>
        <IdMirrorCards />
        <MirroredImageContainer />
      </BreakpointWrapper>
    </Background>
  );
}
